<template>

    <div class="final-narrative-container">
        <div class="compare-container">
            <div class="compare-container-header">
                <span class="header-left">Final Draft</span>
            </div>
            <div class="compare-content">
                <div class="details-container">
                    <div class="compare-select-wrapper">
                        <div class="version-toggle-container">
                            <div class="version-toggle">
                                <button v-if="!hasShortenedVersion" class="toggle-btn active">
                                    Original Version
                                </button>

                                <template v-else>
                                    <div :class="['toggle-btn', { 'active': showOriginal }]"
                                        @click="showOriginal = true">
                                        <img v-if="showOriginal" :src="require('@/assets/icons/check-icon.svg')"
                                            class="check-icon" />
                                        <div class="text">Original Version</div>
                                    </div>

                                </template>
                            </div>

                            <div class="version-actions">
                                <button v-if="showOriginal && !isEditNarrative" class="final-pr"
                                    @click="completeNarrative('ORG')" :disabled="isEditNarrative || isEditingShortened">
                                    <p>Finalize</p>
                                    <img :src="require('@/assets/icons/tick-icon.svg')" />
                                    
                                </button>

                              
                                <div v-if="!isEditNarrative" class="header-right">
                                    <button class="edit-btn" @click="editNarrative('context')"
                                        :disabled="isEditingStrategy || isEditingVision">
                                        <Svg :src="require('@/assets/icons/edit.svg')" fill="black"></Svg>
                                    </button>
                                </div>
                                <div v-else class="header-right">
                                    <button class="save-changes-btn" @click="saveNarrative('context')"
                                        :disabled="previousVersion === editedVersion">
                                        <Svg :src="require('@/assets/icons/save.svg')" fill="#262626"></Svg>
                                        Save Changes
                                        <v-progress-circular v-if="saveLoader" indeterminate :size="20" :width="2"
                                            color="white"></v-progress-circular>
                                    </button>
                                    <button class="edit-btn" @click="cancelChanges('context')">
                                        <img :src="require('@/assets/icons/close.svg')"></img>
                                    </button>
                                </div>

                                
                                <button v-if="showOriginal" class="edit-btn" @click="downloadNarrative('original')">
                                    <v-progress-circular v-if="downloadLoader == 'original'" indeterminate :size="18"
                                        :width="2" />
                                    <img v-else :src="require('@/assets/icons/download.svg')" />
                                </button>



                            </div>
                        </div>
                    </div>
                    <div class="pr-details">
                        <div class="pr-details-wrapper" v-html="currentContent" ref="detailsContainer" :key="refresh"
                            id="edit-container" v-if="!isEditNarrative"></div>
                        <div v-show="isEditNarrative" class="editor-wrapper">
                            <div ref="editorContainer">
                                <div ref="finalDraftEditor" class="quill-editor"></div>
                            </div>
                        </div>

                    </div>
                    <div class="footer-final-btn">
                        <button v-if="showOriginal && !isEditNarrative" class="final-pr"
                            @click="completeNarrative('ORG')" :disabled="isEditNarrative || isEditingShortened">
                            <p>Finalize</p>
                            <img :src="require('@/assets/icons/tick-icon.svg')" />
                        </button>
                    </div>
                </div>
                <div class="details-container">
                    <div class="compare-select-wrapper">
                        <div class="optimized-wrapper">
                            <Svg :src="require('@/assets/icons/star.svg')" fill="#DF009E"></Svg>
                            <div class="optimized-text">
                                Alternate Voice
                            </div>
                        </div>
                        <div class="left-container">
                            <button v-if="!isEditingHumanized" class="final-pr" @click="completeNarrative('HMN')"
                                :disabled="isEditingHumanized">
                                <p>Finalize</p>
                                <img :src="require('@/assets/icons/tick-icon.svg')" />
                            </button>
                            <div v-if="!isEditingHumanized" class="header-right">
                                <button class="edit-btn" @click="editHumanized('context')"
                                    :disabled="isEditingStrategy || isEditingVision">
                                    <Svg :src="require('@/assets/icons/edit.svg')" fill="black"></Svg>
                                </button>
                            </div>
                            <div v-else class="header-right">
                                <button class="save-changes-btn" @click="saveHumanizeNarrative('context')"
                                    :disabled="previousHumanizedVersion === editedHumanizedVersion">
                                    <Svg :src="require('@/assets/icons/save.svg')" fill="#262626"></Svg>
                                    Save Changes
                                    <v-progress-circular v-if="saveLoader" indeterminate :size="20" :width="2"
                                        color="white"></v-progress-circular>
                                </button>
                                <button class="edit-btn" @click="cancelChanges('context')">
                                    <img :src="require('@/assets/icons/close.svg')"></img>
                                </button>
                            </div>
                            <button class="edit-btn" @click="downloadNarrative('alternate')">
                                <v-progress-circular v-if="downloadLoader == 'humanized'" indeterminate :size="18"
                                    :width="2" />
                                <img v-else :src="require('@/assets/icons/download.svg')" />
                            </button>
                        </div>
                    </div>
                    <div class="pr-details">
                        <div class="pr-details-wrapper" v-html="finalNarrativeDetails.humanizedNarrativeData"
                            v-if="!isEditingHumanized"></div>
                        <div v-show="isEditingHumanized" class="editor-wrapper">
                            <div ref="editorContainer">
                                <div ref="humanizedEditor" class="quill-editor"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isEditingHumanized" class="footer-final-btn">
                        <button class="final-pr" @click="completeNarrative('HMN')" :disabled="isEditingHumanized">
                            <p>Finalize</p>
                            <img :src="require('@/assets/icons/tick-icon.svg')" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-overlay :model-value="pageLoader" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Generating</span>
    </v-overlay>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />
</template>

<script>
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import CommonPopup from '@/components/CommonPopup.vue';
import { Eventbus } from '@/plugins/eventBus';
import { marked } from 'marked';
import axiosInstance from '@/axiosInterceptor';
import RotatingLoader from '@/components/CircularProgressBar.vue';
import { downloadPr } from '@/helper/downloadPr';

export default {
    props: {
        modelValue: {
            type: Object
        },
        generateAlternative: {
            type: Boolean
        },
        narrativeName: {
            type: String
        }
    },
    components: {
        CommonPopup, RotatingLoader
    },
    data() {
        return {
            pageLoader: false,
            downloadLoader: null,
            finalDraftEditor: null,
            isEditNarrative: false,
            previousVersion: null,
            editedVersion: null,
            strategyEditor: null,
            isEditingStrategy: false,
            previousStrategyVersion: null,
            editedStrategyVersion: null,
            visionEditor: null,
            isEditingVision: false,
            previousVisionVersion: null,
            editedVisionVersion: null,
            isEditingHumanized: false,
            previousHumanizedVersion: null,
            editedHumanizedVersion: null,
            humanizedEditor: null,
            refresh: 0,
            showCommonPopup: false,
            popupType: null,
            saveLoader: false,
            showOriginal: true,
            hasShortenedVersion: false,
            shortenedContent: '',
            humanizedContent: null,
            isEditingShortened: false,
            previousShortenedVersion: null,
            editedShortenedVersion: null,
            shortenedEditor: null,
        }
    },
    watch: {
        finalNarrativeDetails: {
            deep: true,
            handler(newValue) {
                this.$emit('update:modelValue', newValue);
            }
        },
        isEditNarrative() {
            this.$emit('update:isEditingNarrative', this.isEditNarrative);
        },
    },
    computed: {
        currentContent() {
            return this.renderContent(this.showOriginal ? this.finalNarrativeDetails?.originalNarrativeData : this.shortenedContent);

        },
        finalNarrativeDetails: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    methods: {

        async downloadNarrative(versionType) {
            this.downloadLoader = versionType;
            let payload = {
                narrativeId: this.$route.params.narrativeId,
                flowType: 'NARRATIVE',
                versionType: versionType
            }
             let filename = `${this.narrativeName}_${versionType}`;
             await downloadPr(payload, filename);
             this.downloadLoader = false
        },

        handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'withoutSave') {
                    this.isEditNarrative = false;
                    this.isEditingHumanized = false,
                        this.isEditingShortened = false,
                        this.isEditingStrategy = false;
                    this.isEditingVision = false;

                }
            }
        },
        renderContent(htmlContent) {
            let isMardownContent = this.isMardownContent(htmlContent);

            if (isMardownContent) {
                let parser = new DOMParser();
                let doc = parser.parseFromString(htmlContent, "text/html");
                let divElement = doc.querySelector("div");
                let markdownText;
                if (divElement) {
                    markdownText = divElement.innerHTML;
                }
                else {
                    markdownText = htmlContent;
                }
                marked.setOptions({
                    breaks: true,
                });
                htmlContent = marked.parse(htmlContent);
            }
            let parsedContent = htmlContent
                .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
                .replace(/<ul(?![^>]*style=)/gi, `<ul style="padding-left: 1rem;"`)
                .replace(/<ol(?![^>]*style=)/gi, `<ol style="padding-left: 1rem"`)
                .replace(/^<div>/, '<div style="display: flex; flex-direction: column; gap: 1rem">');

            return parsedContent;

        },
        isMardownContent(content) {
            if (!content || typeof content !== "string") return false;

            const markdownPatterns = [
                /^#{1,6}\s/m,                // headings (#, ##, ###)
                /\*\*[^*]+\*\*/,             // bold **text**
                /_[^_]+_/,                   // italic _text_
                /```[\s\S]*```/,             // fenced code block
                /\[([^\]]+)\]\(([^)]+)\)/,   // links [text](url)
                /^>\s/m,                     // blockquotes
            ];

            if (markdownPatterns.some((pattern) => pattern.test(content))) {
                return true;
            }

            return false;
        },

        async saveNarrative(type) {
            this.saveLoader = true;
            let payload = {
                narrativeId: this.$route.params.narrativeId,
                lastUpdatedStage: 'Final Draft'
            };
            payload.originalNarrativeData = this.finalDraftEditor.root.innerHTML;
            await axiosInstance.put('/narrative/saveDraft', payload)
                .then((response) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'save',
                        message: 'Changes saved successfully',
                    });
                    this.finalNarrativeDetails.originalNarrativeData = this.finalDraftEditor.root.innerHTML;
                    this.refresh += 1;
                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
                .finally(() => {
                    this.saveLoader = false;
                    this.isEditNarrative = !this.isEditNarrative;
                })
        },
        async saveHumanizeNarrative(type) {
            this.saveLoader = true;
            let payload = {
                narrativeId: this.$route.params.narrativeId,
                lastUpdatedStage: 'Final Draft'
            };
            payload.humanizedNarrativeData = this.humanizedEditor.root.innerHTML;
            await axiosInstance.put('/narrative/saveDraft', payload)
                .then((response) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'save',
                        message: 'Changes saved successfully',
                    });
                    this.finalNarrativeDetails.humanizedNarrativeData = this.humanizedEditor.root.innerHTML;
                    this.refresh += 1;
                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
                .finally(() => {
                    this.saveLoader = false;
                    this.isEditingHumanized = !this.isEditingHumanized;
                })
        },
        async saveShortened(type) {
            this.saveLoader = true;
            try {
                const payload = {
                    narrativeId: this.$route.params.narrativeId,
                    shortenNarrativeData: this.shortenedEditor.root.innerHTML,
                    lastUpdatedStage: 'Final Draft'
                };

                await axiosInstance.put('/narrative/saveDraft', payload);

                this.shortenedContent = this.shortenedEditor.root.innerHTML;
                Eventbus.emit('commonSnackbar', {
                    snackType: 'save',
                    message: 'Shortened version saved successfully',
                });
                this.refresh += 1;
            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Failed to save shortened version',
                });
            } finally {
                this.saveLoader = false;
                this.isEditingShortened = false;
            }
        },
        cancelChanges(type) {
            this.popupType = 'withoutSave';
            this.showCommonPopup = true;
        },
        editNarrative(type) {
            this.isEditNarrative = !this.isEditNarrative;
            this.isEditingHumanized = false;
            this.previousVersion = this.finalNarrativeDetails.originalNarrativeData;
            this.editedVersion = this.finalNarrativeDetails.originalNarrativeData;
            this.finalDraftEditor.root.innerHTML = this.finalNarrativeDetails.originalNarrativeData;
        },
        editHumanized(type) {
            this.isEditingHumanized = true;
            this.isEditNarrative = false;
            this.previousHumanizedVersion = this.finalNarrativeDetails.humanizedNarrativeData;
            this.editedhumanizedVersion = this.finalNarrativeDetails.humanizedNarrativeData;
            this.humanizedEditor.root.innerHTML = this.finalNarrativeDetails.humanizedNarrativeData;

        },

        completeNarrative(versionType) {
            this.$emit('complete-action', versionType);
        }
    },
    async mounted() {
        this.finalDraftEditor = new Quill(this.$refs.finalDraftEditor, {
            theme: 'snow',
        });
        this.finalDraftEditor.on('text-change', () => {
            this.editedVersion = this.finalDraftEditor.root.innerHTML;
        });
        this.humanizedEditor = new Quill(this.$refs.humanizedEditor, {
            theme: 'snow'
        });
        this.humanizedEditor.on('text-change', () => {
            this.editedHumanizedVersion = this.humanizedEditor.root.innerHTML;
        });


        this.humanizedContent = this.renderContent(this.finalNarrativeDetails?.humanizedNarrativeData)

    },
}
</script>

<style scoped>
.final-narrative-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2em;
    padding: 0px 24px 40px 24px;
    font-family: 'Inter', sans-serif;
}

.version-toggle-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.version-toggle {
    display: flex;
    gap: 8px;
    border-radius: 5rem;
    padding: 4px;
}

.toggle-btn {
    display: flex;
    gap: 8px;
    padding: 8px 20px;
    border: none;
    background: #FFFFFF33;
    color: #E5E5E5;
    cursor: pointer;
    border-radius: 5rem;
    font-size: var(--normal-font-size);
}

.toggle-btn.active {
    background: white;
    color: var(--primary-font-color);
}

.toggle-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.version-actions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.compare-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0px 16px 40px 16px;
}

.header-left {
    display: flex;
    flex-direction: column;
}

.left-container {
    display: flex;
    gap: 0.5rem;
}

.shorten {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    gap: 8px;
    border-radius: 24px;
    border: 1px solid #FFFFFF33;
    color: white;
    cursor: pointer;
    font-size: 16px;
    line-height: 0.6;
    letter-spacing: 0.1px;
}


.header-right {
    display: flex;
    align-items: center;
    gap: 1em;
}

.details-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    flex: 1;
}

.credit {
    width: 24px;
    height: 24px;
    background: var(--primary-gradient-with-white);
    -webkit-img-fill-color: transparent;
    display: inline-block;
}

.edit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: 50%;
    background: white;
    color: #404040;
    border: 1px solid #A3A3A3;
}

.text-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 24px;
    background: white;
    color: #404040;
    border: 1px solid #A3A3A3;
}

.optimized-text {
    font-size: var(--normal-font-size);
    background: var(--primary-gradient-with-white);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
}

.pr-details {
    display: flex;
    flex-direction: column;
    gap: 2em;
    padding: 2em;
    align-items: left;
    background-color: white;
    border-radius: 24px;
}

.pr-details-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.compare-container-header {
    display: flex;
    gap: 1em;
    align-items: center;
    color: white;
    font-size: var(--header-font-size);
    font-weight: 600;
    text-align: left;
    color: #FAFAFA;
    padding: 2rem 0rem 2rem 0rem;

}


.compare-select-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0em 0.3em;
}

.optimized-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px;
    border: 2px solid #DF009E;
    color: #DF009E;
    border-radius: 24px;
    font-size: 14px;
    background-color: white;

}

.compare-content {
    display: flex;
    justify-content: space-between;
    gap: 2em;
}

.final-pr {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    align-items: center;
    padding: 8px 20px;
    border-radius: 8px;
    background: var(--primary-gradient-with-black);
    color: white;
}

.final-pr img {
    width: 15px;
    height: 20px;
}

.footer-final-btn {
    padding-left: 8px;
    margin-bottom: 1em;
}

.pr-title {
    font-weight: 600;
    font-size: 24px;
}

.dynamic-popup {
    width: 100%;
    background-color: white;
    border-radius: 12px;
    padding: 2em;
    display: flex;
    flex-direction: column;
    align-items: left;
    gap: 2em;
    font-family: 'Inter', sans-serif;
}

.popup-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.popup-title span {
    font-size: 28px;
    background: white;
    color: #171717;
    font-weight: 600;
}

.popup-header .dynamic {
    width: 40px;
    height: 40px;
    color: #030712;
}

.popup-subtitle {
    color: #737373;
    font-weight: 500;
    font-size: 16px;
}

.popup-content .title {
    color: black;
}

.popup-content {
    background-color: #F5F5F5;
    padding: 8px;
    color: #737373;
    display: flex;
    flex-direction: column;
    gap: 8px;

}

.footer-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
}

.standard {
    border-radius: 8px;
    align-items: center;
    padding: 8px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid black;
}

.fine-tune {
    border-radius: 8px;
    display: flex;
    padding: 8px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #030712;
    flex: 1;
    color: var(--secondary-font-color);
}

.standard-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 400;
    font-size: 16px;
    color: black;
    background-color: white;
}

.fine-tune-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 400;
    font-size: 16px;
    background-color: #030712;
    color: white;
}

.credit {
    width: 24px;
    height: 24px;
}

.footer-subtitle {
    font-size: 14px;
    color: var(--secondary-font-color);
}

.standard .footer-subtitle {
    font-size: 14px;
    color: var(--light-grey-color);
}

.circle {
    position: absolute;
    top: 20px;
    right: 40px;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 1em;
    border: 2px solid #D4D4D4;
}

.popup-details {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 0px 12px 0px 8px;
}

.details-title {
    font-size: 28px;
    font-weight: 600;
    text-align: left;
}

.details-subtitle {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #737373;
}

.popup-points {
    color: #404040;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    padding-left: 2em;
}

.popup-points li {
    padding: 4px 0px;
    font-weight: 500;
}

.save-changes-btn {
    width: 11.5rem;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    gap: 0.7rem;
    border-radius: 1.5rem;
    background: white;
    color: #262626;
    border: 1px solid #A3A3A3;
}
</style>